import {inject, Injectable} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
    providedIn: 'root'
})

export class LayoutIconService {
  private iconsStore:string[] = [
    'file-2-fill',
    'settings-3-fill',
    'pie-chart-2-fill',
    'group-fill', 
    'wallet-2-fill',
    'shopping-cart-2-fill',
    'file-copy-2-fill', 
    'task-fill', 
    'file-chart-fill', 
    'pro',
    'layout-grid-fill', 
    'notification-3-fill', 
    'search-line',
    'arrow-down-s-line', 
    'arrow-up-s-line', 
    'arrow-right-s-line', 
    'arrow-left-s-line', 
    'git-repository-fill', 
    'user-add-fill', 
    'logout-box-r-line', 
    'user-shared-fill', 
    'briefcase-line', 
    'user-settings-line',
    'add-box-fill'
]
  constructor () {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    this.iconsStore.forEach(icon=>{
      iconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/icons/'+icon+'.svg'));
    })
  }
}